/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

export const template22 = {
  title: t.to('電光掲示板(現在時刻)', 'title22'),
  desc: t.to(
    `直方体とテキストを使って電光掲示板を作り、そこに現在時刻を表示します`,
    'desc22'
  ),
  img: '../public/template/22.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <comment id="9!ZL(MFs;R]1jr}6OH5t" x="227" y="203" h="508" w="1019">【学べること】
  テキストブロックに現在時刻を表示する方法が学べます。
◆BLOCK部分
  1. 左のBLOCKタブより、"シーンスタート"をドラック＆ドロップします。
  2. 同じく"背景"を持って来て、"シーンスタート"の中に配置し、「背景：湿地」を選択します。
  3. 文字の背景となるボードを作るため、物理の「直方体」を持ってきます。
  4. 文字背景ボードの位置と大きさを設定します。
  5. 文字を両面に表示するため、物理の「半角英数ひらがなカタカナ」を2つ持ってきます。（以下、文字）
  6. 文字の表用を「ID：clock1」、裏用を「ID：clock2」とします。
  7. 文字の色を白にします。
  8. 文字の大きさを指定するため、属性の「大きさ」を持ってきて、指定します。
  9. 文字の裏用を表示するため、属性の「回転」を持ってきて、「Y＝180」と指定します。
◆CODE部分
  A. 初期設定
    1. なし
  B. Loop設定
    1. 変数nowに「new Date().toLocaleString()」で取得した、現在時刻を代入します。
    2. 文字ブロック(clock1、clock2)に表示する値(value)として、setAttributeで、変数nowの値を代入します。</comment>
  <block type="a-scene-start" x="210" y="-150">
    <field name="is_init">off</field>
    <field name="hasController">off</field>
    <statement name="IN">
      <block type="environment_v2">
        <field name="environment">groundTexture:squares;ground:hills;skyType:atmosphere;groundColor:green;groundColor2:green</field>
        <next>
          <block type="cube_v2">
            <field name="id">board</field>
            <field name="position-x">0</field>
            <field name="position-y">10</field>
            <field name="position-z">-5</field>
            <value name="COLOUR">
              <shadow type="color_value_v2">
                <field name="COLOUR">#000000</field>
              </shadow>
            </value>
            <value name="ATTR">
              <block type="scale_v2">
                <field name="scale-x">29</field>
                <field name="scale-y">6</field>
                <field name="scale-z">1</field>
              </block>
            </value>
            <next>
              <block type="a-text_v2">
                <field name="text">hello world こんにちは</field>
                <field name="id">clock1</field>
                <field name="position-x">-13</field>
                <field name="position-y">10</field>
                <field name="position-z">-4.4</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2">
                    <field name="COLOUR">#ffffff</field>
                  </shadow>
                </value>
                <value name="ATTR">
                  <block type="scale_v2">
                    <field name="scale-x">10</field>
                    <field name="scale-y">10</field>
                    <field name="scale-z">1</field>
                  </block>
                </value>
                <next>
                  <block type="a-text_v2">
                    <field name="text">hello world こんにちは</field>
                    <field name="id">clock2</field>
                    <field name="position-x">13</field>
                    <field name="position-y">10</field>
                    <field name="position-z">-5.6</field>
                    <value name="COLOUR">
                      <shadow type="color_value_v2">
                        <field name="COLOUR">#ffffff</field>
                      </shadow>
                    </value>
                    <value name="ATTR">
                      <block type="scale_v2">
                        <field name="scale-x">10</field>
                        <field name="scale-y">10</field>
                        <field name="scale-z">1</field>
                        <value name="ATTR">
                          <block type="rotation_v2">
                            <field name="rotation-x">0</field>
                            <field name="rotation-y">180</field>
                            <field name="rotation-z">0</field>
                          </block>
                        </value>
                      </block>
                    </value>
                  </block>
                </next>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>
`,
  js_code: `forever(()=>{
  /* 現在日時の取得 */
  const now = new Date().toLocaleString()

  /* 現在日時をテキストに設定 */
  clock1.setAttribute('value', 'Now：' + now)
  clock2.setAttribute('value', 'Now：' + now)
})`,
};
